const RootDataState = {
  adData: null,
  adUserId: null,
  adUserName: null,
}

export default RootDataState
